export default "// Light theme\nthis.$vuetify.theme.themes.light.primary = '#4caf50'\n\n// Dark theme\nthis.$vuetify.theme.themes.dark.primary = '#4caf50'\n";